import { useEffect, useState } from 'react';
import { Dialog, DialogContent, Tab } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import L from 'leaflet';

import useTabs from '../../../Lib/UI/Hooks/useTabs';
import { IActionForProvider } from '../../../Lib/Actions/actions';
import SearchPlacesList from './searchPlacesList';
import RecentPlacesList from './recentPlacesList';
import { IPlaceHistoryService, IPlaceSearchResult, IPlaceSearchService } from '../placeSearchTypes';
import PopupAppBar from '../../Common/PopupAppBar';
import PersistentTabPanel from '../../../Lib/UI/Components/PersistentTabPanel';

import uiStyles from "../../../Lib/UI/UI.module.css";


interface SearchPlacesPopupProps {
    placeSearchService: IPlaceSearchService;
    placeHistoryService: IPlaceHistoryService;
    action: IActionForProvider<{ map: L.Map, biasBounds?: L.LatLngBounds | null }, IPlaceSearchResult>;
    maxResults?: number;
}

const SearchPlacesPopup = (props: SearchPlacesPopupProps): JSX.Element => {

  const tabs = useTabs('search');
  const [biasBounds, setBiasBounds] = useState<L.LatLngBounds | null>(null);

  useEffect(() => {
    if (!!props.action.params) {
      setBiasBounds(props.action.params.biasBounds ?? null);
    }
  }, [props.action.params]);

  const handleOnView = (item: IPlaceSearchResult) => {
    props.placeHistoryService.add(item)
      .then(() => props.action.complete(item));
  };


  return (        
      <Dialog
          fullScreen
          open={props.action.isActive}
          onClose={props.action.cancel}
      >
      <PopupAppBar title="Search for Places" icon={<SearchIcon/>} onClose={props.action.cancel} showNetworkStatus={true}/>

      <DialogContent>

        <TabContext value={tabs.value}>

          <TabList onChange={tabs.handleChange} variant="fullWidth">
            <Tab label="Search" value="search" />
            <Tab label="Recent" value="recent" />
          </TabList>

          <PersistentTabPanel value="search" className={uiStyles.tab_panel}>
            <SearchPlacesList placeSearchService={props.placeSearchService} biasBounds={biasBounds} maxResults={props.maxResults} onView={handleOnView} />
          </PersistentTabPanel>

          <PersistentTabPanel value="recent" className={uiStyles.tab_panel}>
            <RecentPlacesList placeHistoryService={props.placeHistoryService} onView={props.action.complete}/>
          </PersistentTabPanel>

        </TabContext>

      </DialogContent>

    </Dialog>
  );
};

export default SearchPlacesPopup;